import { createRelationshipStatusColDef } from '../../../../../components/shared-columns/relationship-status';
import type { InvestorCoverageRow } from '../InvestorCoverageGrid.model';
import { isInvestorCoverageColumnEditable } from './columns.model';

export const relationshipStatusColDef = createRelationshipStatusColDef<InvestorCoverageRow>({
  editable: isInvestorCoverageColumnEditable,
});
